<template>
  <div class="modalTable">
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-button @click="funcFilter()">查询</el-button>
        <el-button @click="addCapacityDriver">新增</el-button>
      </template>
    </vxe-toolbar>

    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      :loading="loading"
      :checkbox-config="{ highlight: true }"
      :data="tableData"
      row-id="code"
      align="center"
      auto-resize
    >
      <!-- 手机号 -->
      <vxe-table-column>
        <vxe-table-column
          fixed="left"
          field="phone"
          title="手机号"
          min-width="150"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="实际承运人手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 实际承运人姓名 -->
      <vxe-table-column>
        <vxe-table-column
          fixed="left"
          field="name"
          title="实际承运人姓名"
          min-width="130"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 实际承运人状态 -->
      <vxe-table-column>
        <vxe-table-column
          field="driverStatus"
          title="实际承运人状态"
          :formatter="formatterReviewStatus"
          min-width="130"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.driverStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in reviewOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 车牌号码 -->
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseNumber"
          title="车牌号码"
          min-width="130"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicenseNumber"
            placeholder="车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 车辆状态 -->
      <vxe-table-column>
        <vxe-table-column
          field="vehicleStatus"
          :formatter="formattervehicleStatus"
          title="车辆状态"
          min-width="130"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in reviewOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <!-- 负载状态 -->
      <vxe-table-column>
        <vxe-table-column
          field="loadStatusName"
          title="负载状态"
          min-width="130"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.loadStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 载重 -->
      <vxe-table-column>
        <vxe-table-column
          field="loadWeight"
          title="载重"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.loadWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.loadWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>

      <!-- 车型 todo -->
      <vxe-table-column>
        <vxe-table-column
          field="classificationCodeName"
          title="车型"
          min-width="130"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.classificationCode"
            placeholder="请选择"
            clearable
            filterable
          >
            <el-option
              v-for="item in vehicleClassification"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              clearable
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 车长 todo！！！！！-->
      <vxe-table-column>
        <vxe-table-column field="vehicleLength" title="车长" min-width="130" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLength"
            placeholder="车长"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 身份证到期日期 -->
      <vxe-table-column>
        <vxe-table-column
          field="idCardDueDate"
          title="身份证到期日期"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.idCardDueDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'idCardDueDate')"
          />
        </template>
      </vxe-table-column>
      <!-- 驾驶证到期日期 -->
      <vxe-table-column>
        <vxe-table-column
          field="driverLicenseDueDate"
          title="驾驶证到期日期"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'driverLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <!-- 道路运输从业资格证到期日期 -->
      <vxe-table-column>
        <vxe-table-column
          field="workLicenseDueDate"
          title="道路运输从业资格证到期日期"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.workLicenseDueDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'workLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <!-- 车辆行驶证到期日期 -->
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseDueDate"
          title="车辆行驶证到期日期"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.vehicleLicenseDueDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'vehicleLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <!-- 道路运输证到期日期 -->
      <vxe-table-column>
        <vxe-table-column
          field="roadTransportCertificateDate"
          title="道路运输证到期日期"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.roadTransportCertificateDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'roadTransportCertificateDate')"
          />
        </template>
      </vxe-table-column>
      <!-- 添加时间 -->
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreatedTime"
          title="添加时间"
          min-width="300"
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreatedTime')"
          />
        </template>
      </vxe-table-column>
      <!-- 操作 删除-->
      <vxe-table-column title="操作" min-width="80" fixed="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="详情" placement="top">
            <vxe-button type="text" @click="deleteDriver(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="showAdd"
      title="添加实际承运人"
      width="1000"
      resize
      @close="closeDatas()"
    >
      <DesignatedAdd
        v-if="showAdd"
        ref="Driver"
        @updateList="updateList"
        @close="showAdd = false"
      />
    </vxe-modal>
  </div>
</template>

<script>
import { getListDict } from "@/api/commonApi";
import DesignatedAdd from "./components/DesignatedAdd.vue";
import {
  tedDriver,
  createDriverForRepeatGroup,
  acceptVehicleDriverList,
  deleteAcceptVehicle
} from "@/api/orderform";
export default {
  name: "Child",
  components: {
    DesignatedAdd
  },
  data() {
    return {
      vehicleClassification: [],
      reviewOptions: [
        { label: "未审核", value: 0, color: "gray" },
        { label: "审核中", value: 1, color: "#0000ff" },
        { label: "审核未通过", value: 2, color: "#ff0000" },
        { label: "审核通过", value: 3, color: "#00bd93" }
      ],
      showAdd: false,
      loading: false,
      tableData: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
        // driverType: "3",
        // driverType: "6",
        // name: "",
        // phone: "",
        // headImg: "",
        // linkMan: "",
        // vehicleLicenseNumber: "",
        // vehicleLength: "",
        // vehicleClassification: "",
        // vehicleLoadStatus: "",
        // isFreeze: "0",
        // authStatus: "3",
        // workStatus: "1",
        // authStatusExt: "3",
        // branchCodeExt: ""
      },
      // selectArrs: [],
      Pagingconf: [],
      selectRecords: [],
      options: [
        {
          value: 0,
          label: "空载"
        },
        {
          value: 1,
          label: "负载"
        }
      ]
    };
  },

  computed: {
    // 创建reviewOptions的Map缓存，提升查找性能
    reviewOptionsMap() {
      if (!this.reviewOptions) return new Map();
      return new Map(this.reviewOptions.map(item => [item.value, item.label]));
    }
  },

  created() {
    this.checkList();
    this.findList();
  },
  methods: {
    checkList() {
      getListDict({
        types:
          "app_vehicleClassification,app_vehicleLength,vehicleClassification,vehicleWidth,vehicleHigh,vehicleTonnage,locationSource,vehicleEnergyType,vehicleLicenseColor,vehicleLength"
      }).then(response => {
        this.vehicleClassification = response.data.filter(
          item => item.type === "vehicleClassification"
        )[0]["dictList"];
        this.$forceUpdate();
      });
    },
    formatterReviewStatus({ row }) {
      const { driverStatus } = row;
      console.log("实际承运人状态===", driverStatus);
      console;
      if (driverStatus === undefined || driverStatus === null) {
        return "-";
      }
      let status = +driverStatus;
      let label =
        this.reviewOptions.find(item => item.value === status).label || "-";

      return label;
    },
    formattervehicleStatus({ row }) {
      const { vehicleStatus } = row;
      console.log("车辆状态===", vehicleStatus);
      if (vehicleStatus === undefined || vehicleStatus === null) {
        return "-";
      }
      let status = +vehicleStatus;
      let label =
        this.reviewOptions.find(item => item.value === status).label || "-";

      return label;
    },
    deleteDriver(code) {
      console.log("code======", code);
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteAcceptVehicle({ codes: code }).then(res => {
          if (res.status === 0) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.findList();
          }
        });
      });
    },
    updateList() {
      this.showAdd = false;
      this.findList();
    },
    addCapacityDriver() {
      this.showAdd = true;
    },
    handlePageChange() {
      console.log("切换页数===", this.listQuery.pageNum);
      this.findList();
      //将本页所选中的数值，table赋值选中复选框
    },

    closes() {
      this.listQuery = {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        driverType: "3",
        name: "",
        phone: "",
        headImg: "",
        linkMan: "",
        vehicleLicenseNumber: "",
        vehicleLength: "",
        vehicleClassification: "",
        vehicleLoadStatus: "",
        isFreeze: "0",
        authStatus: "3",
        workStatus: "1",
        authStatusExt: "3",
        branchCodeExt: ""
      };
      // console.log("1111111111", this.selectArrs);
      // this.selectArrs = [];
      this.selectedDrivers = []; // 清空选中的实际承运人列表
    },

    findList() {
      this.loading = true;

      acceptVehicleDriverList(this.listQuery).then(response => {
        this.loading = false;
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
      });
    },
    // 电话号码脱敏方法
    maskPhone(phone) {
      if (!phone) return "";
      const phoneStr = phone.toString();
      if (phoneStr.length === 11) {
        // 11位手机号：显示前3位和后4位，中间4位用*替换
        return phoneStr.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      } else if (phoneStr.length >= 7) {
        // 其他长度的电话号码：保留前3位和后4位，中间用*替换
        const start = phoneStr.substring(0, 3);
        const end = phoneStr.substring(phoneStr.length - 4);
        const middle = "*".repeat(phoneStr.length - 7);
        return start + middle + end;
      }
      return phoneStr; // 长度不足7位的直接返回原值
    },
    getSelectEvent() {
      let selectRecords = this.$refs.xTable.getSelectRecords();
      console.log("selectRecords", selectRecords);
      if (selectRecords.length > 0) {
        this.$emit("event", selectRecords, 0);
      } else {
        this.$message({ message: "请至少选择一个实际承运人", type: "warning" });
      }
    },
    // 删除选中的实际承运人tag
    removeDriver(driver) {
      console.log("this.selectedDrivers======", this.selectedDrivers);
      const index = this.selectedDrivers[this.listQuery.pageNum - 1].findIndex(
        item => item.code === driver.code
      );
      if (index > -1) {
        this.selectedDrivers[this.listQuery.pageNum - 1].splice(index, 1);
      }

      // 取消table中对应行的选中状态
      this.$refs.xTable.setCheckboxRow(driver, false);
      this.$forceUpdate();

      // 同步更新selectArrs
      // const selectIndex = this.selectArrs.findIndex(
      //   item => item.code === driver.code
      // );
      // if (selectIndex > -1) {
      //   this.selectArrs.splice(selectIndex, 1);
      // }
    }
  }
};
</script>

<style scoped>
.tag_wrap {
  margin-top: 10px;
  padding: 10px;
  border-top: 1px solid #ebeef5;
  /* 禁止选中 */
  user-select: none;
}
</style>
